import { ServiceTargetIds } from './index';

export const DEFAULT_SELECT_TARGET_OPTIONS = {
  [ServiceTargetIds.CORE]: {
    showOnlyCompanies: false,
    showOnlyManagedByAbove: false,
    showExcludedFolder: false,
    targetsMode: true,
    protectedEntitiesTypes: null,
  },
  [ServiceTargetIds.SVE]: {
    showOnlyCompanies: false,
    showOnlyManagedByAbove: true,
    showExcludedFolder: false,
    targetsMode: true,
    protectedEntitiesTypes: null,
  },
  [ServiceTargetIds.EPS]: {
    showOnlyCompanies: false,
    showOnlyManagedByAbove: false,
    showExcludedFolder: false,
    targetsMode: true,
    protectedEntitiesTypes: null,
  },
  [ServiceTargetIds.MDM]: {
    showOnlyCompanies: false,
    showOnlyManagedByAbove: true,
    showExcludedFolder: true,
    targetsMode: true,
    protectedEntitiesTypes: null,
  },
};

export const DEFAULT_DATAPROVIDER_CONSOLE_REQUESTS = {
  SVE: {
    rootNode: {
      endpoint: 'ProtectedEntitiesSVE',
      method: 'getRoot',
    },
    childNodes: {
      endpoint: 'ProtectedEntitiesSVE',
      method: 'getNodeChildren',
    },
  },
  EPS: {
    rootNode: {
      endpoint: 'ProtectedEntitiesEPS',
      method: 'getRoot',
    },
    childNodes: {
      endpoint: 'ProtectedEntitiesEPS',
      method: 'getNodeChildren',
    },
  },
  MDM: {
    rootNode: {
      endpoint: 'ProtectedEntitiesMDM',
      method: 'getRoot',
    },
    childNodes: {
      endpoint: 'ProtectedEntitiesMDM',
      method: 'getNodeChildren',
    },
  },
};
